import UserModel from "src/models/UserModel";
import { RequiredFields } from "./constants";

interface ShouldDisplayFieldsInput {
  user: UserModel;
  requiredFields: RequiredFields[];
  field: RequiredFields;
}

export default function shouldDisplayField({
  user,
  requiredFields,
  field,
}: ShouldDisplayFieldsInput) {
  const result = {
    display: false,
    required: false,
  };

  // console.log("user", user);

  if (user && !user?.id?.includes("-")) {
    if (requiredFields.includes(field)) {
      result.display = true;
    }

    if (requiredFields.includes(`${field}Required` as RequiredFields)) {
      result.required = true;
    }

    if (user.isAdminOrAbove) {
      result.display = true;
      result.required = false;
    }
  } else {
    if (requiredFields.includes(field)) {
      result.display = true;

      if (requiredFields.includes(`${field}Required` as RequiredFields)) {
        result.required = true;
      }
    }
  }

  return result;
}
